<template>
  <Content>
    <div class="md-layout">
      <div class="md-layout-item md-size-530">
        <div class="md-card-perfil">
            <md-card-content>
              <div class="md-layout-item md-size-500">
                <label>Domínio Sistemas</label>
                <md-field>
                  <label>Cliente ID Gerado na Contabilidade</label>
                  <md-input
                    v-model="accountantIntegrations.dominioSistemas.configuration.integrationKey"
                    placeholder="Cliente ID Gerado na Contabilidade"/>
                </md-field>
                <md-switch v-model="accountantIntegrations.dominioSistemas.active">Ativo</md-switch>
                <md-button
                  class="md-raised btn-atualizar-mail"
                  @click="save()">Salvar
                </md-button>
              </div>
            </md-card-content>
          </div>
        </div>
    </div>
    </Content>
  </template>
  <script>
  import moment from 'moment';
  import { http } from '../../public/api/backend'
  import Content from '../../client/public/Content.vue';
  import Pagination from '../../public/pagination/Pagination.vue';
  
  
  export default {
    name: 'Integrations',
    components: {
      Content,
      moment,
      Pagination,
    },
    data() {
      return {
        accountantIntegrations: {
          dominioSistemas: {
            active: false,
            configuration: {},
            integrationId: 1,
          }
        }
      };
    },
    async mounted() {
      await this.get()
    },
    methods: {
      async save() {
        await http.post('integrations.persist-configuration', {
          ...this.accountantIntegrations
        })
        this.$toasted.show('Informações gravadas com sucesso!', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
        });
      },
      async get() {
        const { data } = await http.post('integrations.get-configurations');
        if (Object.keys(data).length) {
          this.accountantIntegrations = data;
        }
      }
    },
  };
</script>
  


// WEBPACK FOOTER //
// src/accountant/integrations/Integrations.vue